import { render, staticRenderFns } from "./NameOwnerModal.vue?vue&type=template&id=0891fec2&scoped=true"
import script from "./NameOwnerModal.vue?vue&type=script&lang=js"
export * from "./NameOwnerModal.vue?vue&type=script&lang=js"
import style0 from "./NameOwnerModal.vue?vue&type=style&index=0&id=0891fec2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0891fec2",
  null
  
)

export default component.exports